<ng-container *ngIf="!multiple; else withMultipleProducts">
  <ng-container
    *ngTemplateOutlet="
      summaryTemplate;
      context: {
        windowSticker: product,
        project: project,
        projectContactToCompanySubject: projectContactToCompanySubject
      }
    "
  ></ng-container>
</ng-container>

<ng-template #withMultipleProducts>
  <mat-card class="top-card mat-elevation-z0 multiple-products-summary-card">
    <ng-container
      *ngTemplateOutlet="
        summaryTemplate;
        context: {
          windowSticker: product,
          project: project,
          projectContactToCompanySubject: projectContactToCompanySubject
        }
      "
    ></ng-container>
  </mat-card>
</ng-template>

<ng-template
  #summaryTemplate
  let-windowSticker="windowSticker"
  let-project="project"
  let-projectContactToCompanySubject="projectContactToCompanySubject"
>
  <div class="summary-card-container">
    <div class="summary-card-header">
      Configuratie
    </div>
    <mat-card class="top-card mat-elevation-z0 summary-card black-border-color">
      <div class="small-upper-space configuration-container">
        <div class="bold-card-title">
          {{ windowSticker.calculatedTypeLabel }}
        </div>
        <div class="upper-space">
          <div
            *ngFor="
              let part of windowSticker.clientStickerParts;
              let i = index;
              let count = count
            "
          >
            <ng-container
              *ngIf="
                part.instance != null &&
                part.partType === CLIENT_STICKER_PART_TYPE.STANDARD_STICKER_PART
              "
            >
              <ng-container
                *ngTemplateOutlet="
                  standardStickerPart;
                  context: {
                    part: part.instance,
                    index: i,
                    count: count,
                    client: client
                  }
                "
              >
              </ng-container>
            </ng-container>
            <ng-container
              *ngIf="
                part.instance != null &&
                part.partType === CLIENT_STICKER_PART_TYPE.STICKER_PART
              "
            >
              <ng-container
                *ngTemplateOutlet="
                  stickerPart;
                  context: {
                    part: part.instance,
                    index: i,
                    count: count,
                    client: client
                  }
                "
              >
              </ng-container>
            </ng-container>
          </div>
          <div>
            {{
              windowSticker.temporaryMaterial
                | formatBoolean: false:'Tijdelijk':'Permanent'
                | joiner
                  : ' - '
                  : windowSticker.foil?.name
                  : windowSticker.laminate?.name
            }}
          </div>
        </div>
      </div>
    </mat-card>
  </div>
  <client-non-ip-board-design-summary
    [product]="windowSticker"
    [project]="project"
    [client]="client"
    [projectContactToCompanySubject]="projectContactToCompanySubject"
  ></client-non-ip-board-design-summary>
</ng-template>

<ng-template
  #standardStickerPart
  let-part="part"
  let-index="index"
  let-count="count"
>
  <div>
    <span *ngIf="count > 1" class="strong">Deelsticker #{{ index + 1 }}: </span>
    <span>{{
      part.productSize?.height | formatProductSize: part.productSize?.width
    }}</span>
  </div>
</ng-template>

<ng-template #stickerPart let-part="part" let-index="index" let-count="count">
  <div>
    <span *ngIf="count > 1" class="strong">Deelsticker #{{ index + 1 }}:</span>
    <span>
      Raam:
      {{ part.windowHeight | formatProductSize: part.windowWidth | or: '/' }}
    </span>
    <span class="preserve-line-break"> - </span>
    <span class="strong">
      Sticker:
      {{ part.stickerHeight | formatProductSize: part.stickerWidth | or: '/' }}
    </span>
  </div>
</ng-template>
